import { BODY_SHAPE_OPTIONS } from '../BODY_SHAPE_OPTIONS';
import { BodyShapeOptionIdType } from '../types';

const DEFAULT: BodyShapeOptionIdType = 'muscular';

export const getBodyShapeIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): BodyShapeOptionIdType | null => {
  const id = BODY_SHAPE_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
